export const DEFAULT_PAGE_LIMIT = 10

export const SEARCH_DEBOUNCE_TIME_IN_MS = 350

export const YANDEX_MAPS_API_KEY = '12c8e8c8-7398-40de-8647-5a76f3c879df'
